import { render, staticRenderFns } from "./OsobaTvrtkaEdit.vue?vue&type=template&id=39f3979a&scoped=true&"
import script from "./OsobaTvrtkaEdit.vue?vue&type=script&lang=js&"
export * from "./OsobaTvrtkaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3979a",
  null
  
)

export default component.exports